<template>
  <div id="group_home_page_outer" v-if="user != null">
    <div id="group_home_page_left" :class="[borderColor]">

      <div style="position: relative;" @mouseenter="headerShow" @mouseleave="headerHide">
        <img id="group_home_page_user_img" :class="borderColor" :src="headIcon">
        <div class="header-fore-div" v-if="showHeadImgForDiv" @click="headIconClicked">
          <span class="iconfont" style="color: white;font-size: 2rem;">&#xe672;</span>
        </div>
      </div>

      <div class="group_home_page_label_1">您好</div>
      <div class="group_home_page_left_name">{{user.nickname}}</div>

      <div class="group_home_page_label_2">我的信息完整度</div>
      <div id="person_home_page_stars_out">
        <img
          v-for="index in [1,2,3,4,5]"
          :src="starValue >= index ? selectedStarImg : normalStarImg"
          :key="'group_home_page_star_' + index"
        >
      </div>

      <div class="group_home_page_label_3" >{{starValue == 5 ? '太棒了，获得5星！' : '立即完善信息，提升我的信息完整度！'}}</div>
    </div>
    <div id="group_home_page_right" :class="[borderColor]">
        <div>
            <table style="width: 100%;">
              <thead>
              <tr>
                <td >
                  <div class="header-left-td" style="">
                    <div :class="[textColor,]" style="padding: 10px 0;width: 90px;">团体信息</div>
                    <a href="javascript:void(0);"
                       v-show="!isEdting"
                       @click="beginEditing"
                    ><img :src="editImg" ></a>
                  </div>
                </td>
                <td >
                  <input v-show="isEdting" style="background-color: transparent;color: #666;border: solid 1px #aaa;margin-right: 5px;" type="button" value="取消" @click="submitCancel" >
                  <input v-show="isEdting" :class="[specBackgroundColor]" type="button" value="提交" @click="submitUserEdit" >
                </td>
              </tr>
              </thead>

              <tbody>
                <tr>
                  <th>名称：</th>
                  <td>
                    <div v-if="!isEdting">{{(user.name == null || user.name.length == 0) ? user.nickname : user.name}}</div>
                    <input :class="borderColor"
                           v-else
                           type="text"
                           placeholder="请填入团体名称"
                           v-model="teamName"
                    >
                  </td>
                </tr>
                <tr>
                  <th>类型：</th>
                  <td>
                    <div >{{groupTypeText}}</div>

                    <input
                      :class="borderColor"
                      style="margin-top: 10px;"
                      type="text"
                      v-if="false"
                      placeholder="请输入具体名称"
                      @change="groupTypeDescChanged"
                      v-model="teamTypeName"
                    >
                  </td>
                </tr>

                <tr>
                  <th>成立日期：</th>
                  <td>
                    <div v-if="!isEdting">{{createDate}}</div>

                    <date-picker v-else
                                :format="'yyyy-MM-dd'"
                                 v-model="teamCreateDate"
                                 :placeholder="'请输入日期'"
                                 :language="zh"
                                 :input-class="[borderColor, 'date-input-class']"
                    ></date-picker>
                  </td>
                </tr>

                <tr>
                  <th>联系人姓名：</th>
                  <td>
                    <div v-if="!isEdting">{{user.contacts == null ? '暂无' : user.contacts}}</div>
                    <input :class="borderColor"
                           v-else
                           type="text"
                           placeholder="请填入姓名"
                           v-model="teamAgentName"
                    >
                  </td>
                </tr>

                <tr>
                  <th>联系人电话：</th>
                  <td>
                    <div v-if="!isEdting">{{(user.tel == null || user.tel.length == 0) ? '暂无' : user.tel }}</div>
                    <input :class="borderColor"
                           v-else type="text"
                           placeholder="请输入电话"
                           v-model="teamAgentPhone"
                    >
                  </td>
                </tr>

                <tr>
                  <th>所在地区：</th>
                  <td>
                    <div v-if="!isEdting">{{(user.area == null || user.area.length == 0) ? '暂无' : user.area}}</div>
                    <v-distpicker
                      v-else
                      :province="teamArea.province"
                      :city="teamArea.city"
                      :area="teamArea.area"
                      @selected="areaSelected"
                      :wrapper="dispatcherWrapperClass"
                    />
                  </td>
                </tr>

                <tr>
                  <th>简介：</th>
                  <td>
                    <div v-if="!isEdting" v-html="(user.desc == null || user.desc.length == 0) ? '暂无' : user.desc"></div>
                    <textarea v-else
                              :class="[borderColor]"
                              maxlength="200"
                              placeholder="请输入简介（200字以内）"
                              name="profile"
                              v-model="teamProfile"
                    />
                  </td>
                </tr>

              </tbody>

            </table>

        </div>
        <div >
          <div style="min-height: 100px;">
            <div :class="['group_home_right_title', textColor]">团体会员</div>
            <div v-if="(user.isMember == 0 || user.isMember == null)"
                 style="color:#666;font-size: 1rem;margin-top: 4px;line-height: 1.5rem;">
              尚未成为认证会员，
              <a href="/introduce/0203" style="text-decoration: none;">什么是协会会员？</a><br>
              <a href="javascript:void(0)" v-if="isCanVipOperated && isOfficialOpened" @click="gotoVipApplicationPage" style="text-decoration: none;">立即申请>>></a>
            </div>
            <div v-else-if="memberValid == true"
                 style="color:#666;font-size: 1rem;margin-top: 4px;line-height: 1.5rem;"
            >
              已成为认证会员<br>
              有效期至{{memberValidDateText}}
            </div>
            <div v-else style="color:#666;font-size: 1rem;margin-top: 4px;line-height: 1.5rem;">
              会员已过期<a v-if="isCanVipOperated && isOfficialOpened" href="javascript:void(0)" @click="gotoVipApplicationPage" style="text-decoration: none;margin-left: 5px;">前往年审>>></a>
            </div>
          </div>
          <div style="margin-top: 4vh;" v-if="user.isMember == 1">
            <div :class="['group_home_right_title', textColor]">旗下成员</div>

            <div v-if="user.memberStat != null && user.memberStat.length > 0">
              <div v-for="(item, index) in user.memberStat" :key="'group_home_member_' + index" style="color:#666;font-size: 1rem;margin-top: 4px;line-height: 1.5rem;">
                {{item.typeName + item.num + '名'}}
              </div>
            </div>
            <div v-else style="color:#666;font-size: 1rem;margin-top: 4px;line-height: 1.5rem;">
              暂无旗下成员
            </div>
          </div>
        </div>
    </div>
    <headportrait-select v-if="showHeadportraitEditing" @close="closeHeadportraitSelect" />
  </div>
</template>

<script>
  import NormalStarImg from '../../assets/shl_home_page_star_normal.png';
  import SelectdStarImg from '../../assets/shl_home_page_star_selected.png';
  import RedNormalStarImg from '../../assets/shl_home_page_red_star_normal.png';
  import RedSelectedStarImg from '../../assets/shl_home_page_red_star_selected.png';
  import GoldEditImg from '../../assets/shl_editing_gold_img.png';
  import RedEditImg from '../../assets/shl_editing_red_img.png';

  import HeadRedImage from '../../assets/shl_group_head_portrait_red_default.png';
  import HeadGoldImage from '../../assets/shl_group_head_portrait_gold_default.png';


  import VDistpicker from 'v-distpicker';
  import DatePicker from 'vuejs-datepicker';
  import Lzh from "vuejs-datepicker/dist/locale/translations/zh";

  import HeadportraitSelect from "../HeadportraitSelect/HeadportraitSelect";

  export default {
    name: "GroupHomePage",
    components: {
      VDistpicker,
      DatePicker,
      HeadportraitSelect,
    },
    data() {
      return {
        title: '我的主页',
        goldStar: {
          normStarImg: NormalStarImg,
          selectedStarImg: SelectdStarImg,
        },
        redStar: {
          normStarImg: RedNormalStarImg,
          selectedStarImg: RedSelectedStarImg,
        },
        isEdting: false,

        groupTypeList: [
          {
            title: '区篮协',
            value: '11',
          },
          {
            title: '企业',
            value: '12',
          },
          {
            title: '学校',
            value: '13',
          },
          {
            title: '社会团体',
            value: '14',
          },
          {
            title: '其他',
            value: '0',
          },
        ],
        showHeadportraitEditing: false,
        zh: Lzh,

        tempTypeValue: null,

        teamName: null,
        teamType: null,
        teamTypeDesc: null,
        teamCreateDate: null,
        teamAgentName: null,
        teamAgentPhone: null,
        teamArea: {
          province: null,
          city: null,
          area: null,
        },
        teamProfile: null,

        showHeadImgForDiv: false,
        judgeApplyDuration: null,
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },

      isVip() {
        if (this.user == null) {
          return false;
        }
        let user = this.user;
        let memberValidDate = user.memberValidDate;

        if (memberValidDate == null) {
          return false;
        }
        return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
      },

      isOfficialOpened() {
        console.log('000001');
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        return false;
      }
      let beginString = judgeApplyDuration.begin;
      let enditString = judgeApplyDuration.end;
      let beginDate = this.$moment(beginString);
      let endDate = this.$moment(enditString);
      let now = this.$moment(this.$moment().format("yyyy-MM-DD"), "yyyy-MM-DD");
      console.log(beginString);
      console.log(enditString);
      if ((now - beginDate) >= 0 && (now - endDate) <= 0) {
        return true;
      }
      return false;
    },

    typeNameAllowedList() {
      return this.$store.state.typeNameAllowedList
    },
    isCanVipOperated() {
      let user = this.user;
      if (user == null) {
        return false;
      }
      let typeName = user.typeName;
      if (typeName == null || typeName == '' || this.typeNameAllowedList.indexOf(typeName) >= 0) {
        return true;
      }
      return false;
    },

      starValue() {
        let value = 0;
        let user = this.user;
        let name = user.name;
        if (name != null && name.length > 0) {
          value ++;
        }

        let desc = user.desc;
        if (desc != null && desc.length > 0) {
          value ++;
        }

        let type = user.type;
        if (type != null && type != undefined) {
          value ++;
        }

        let foundedDate = user.foundedDate;
        let area = user.area;
        if (foundedDate != null && this.$moment(foundedDate).isValid() && (area != null && area.length > 0)) {
          value ++;
        }

        let tel = user.tel;
        let contacts = user.contacts;
        if (tel != null && tel.length > 0 && (contacts != null && contacts.length > 0)) {
          value ++;
        }
        return value;
      },
      userHeadDefault() {
        return this.isVip ? HeadGoldImage : HeadRedImage;
      },
      headIcon() {
        if (this.user == null || this.user.headPortrait == null) {
          return this.userHeadDefault;
        } else  {
          return this.user.headPortrait;
        }
      },
      themeValue() {
        return this.isVip ? 1 : 0;
      },
      normalStarImg() {
        return this.themeValue == 0 ? this.redStar.normStarImg : this.goldStar.normStarImg;
      },
      selectedStarImg() {
        return this.themeValue == 0 ? this.redStar.selectedStarImg : this.goldStar.selectedStarImg;
      },
      borderColor() {
        return this.themeValue == 0 ? 'border-red-color' : 'border-gold-color';
      },
      textColor() {
        return this.themeValue == 0 ? 'shba-no-vips-color' : 'shba-vips-color';
      },
      editImg() {
        return this.themeValue == 0 ? RedEditImg : GoldEditImg;
      },
      specBackgroundColor() {
        return this.themeValue == 0 ? 'background-red-color' : 'background-gold-color'
      },
      groupTypeText() {
        return this.user.typeName == null ? '暂无' : this.user.typeName;
      },

      createDate() {
        let createTime = this.user.foundedDate;
        if (createTime == undefined || createTime == null) {
          return '暂无';
        }
        return  this.$moment(createTime).format('YYYY-MM-DD');
      },
      dispatcherWrapperClass() {
        return this.themeValue == 0 ? 'area-dispatcher-red' : 'area-dispatcher-gold';
      },
      memberValid() {
        if (this.user == null || this.user.memberValidDate == null || this.user.memberValidDate.length > 0){
          return false;
        }

        let validDate = new Date(this.user.memberValidDate);
        let now = new Date();
        let inetrval = validDate - now;
        return inetrval > 0;
      },
      memberValidDateText() {
        if (this.user == null || this.user.memberValidDate == null || this.user.memberValidDate.length > 0){
          return '暂无';
        }

        // let validDate = new Date(this.user.memberValidDate);
        // let dateText = validDate.getFullYear() + '年' + (validDate.getMonth() + 1) + '月' + validDate.getDate() + '日';
        return this.$moment(this.user.memberValidDate).format('yyyy年MM月DD日');
      },
    },
    mounted() {
      this.getJudgeApplyDuration();
    },
    methods: {

      gotoVipApplicationPage() {
      this.$router.push({
        name: 'groupApplicationVue'
      });
    },

      headerShow() {
        this.showHeadImgForDiv = true;
      },
      headerHide() {
        this.showHeadImgForDiv = false;
      },

      getJudgeApplyDuration() {
        let judgeApplyDuration = this.$store.state.judgeApplyDuration;
        if (judgeApplyDuration == null) {
          let _this = this;
          setTimeout(function function_name(argument) {
            _this.getJudgeApplyDuration();
          }, 50);

          return;
        }
        this.judgeApplyDuration = judgeApplyDuration;
      },

      beginEditing() {
        this.isEdting = true;

        this.teamName = (this.user.name == null || this.user.name.length == 0) ? this.user.nickname : this.user.name;
        this.teamType = this.user.type == null ? this.groupTypeList[0].value : this.user.type;
        this.teamTypeName = this.user.typeName == null ? '' : this.user.typeName;

        this.teamCreateDate = this.user.foundedDate == null ? '' : this.user.foundedDate;
        this.teamProfile = this.user.desc == null ? '' : this.user.desc;
        this.teamAgentName = this.user.contacts == null ? '' : this.user.contacts;
        this.teamAgentPhone = this.user.tel == null ? '' : this.user.tel;

        if (this.user.area == null) {
          this.teamArea = {
            province: '上海市',
            city: '上海市',
            area: '杨浦区',
          };
        } else {
          let area = this.user.area;
          let areaList = area.split(',');
          let tempObj = {};
          if (areaList.length > 0) {
            tempObj.province = areaList[0];
            tempObj.city = areaList[1];
            tempObj.area = areaList[2];
            this.teamArea = tempObj;
          } else {
            this.teamArea = {
              province: '上海市',
              city: '上海市',
              area: '杨浦区',
            };
          }
        }
      },

      areaSelected(data) {
        this.teamArea.province = data.province.value;
        this.teamArea.city = data.city.value;
        this.teamArea.area = data.area.value;
      },

      closeHeadportraitSelect() {
        this.showHeadportraitEditing = false;
      },
      headIconClicked() {
        this.showHeadImgForDiv = false
        this.showHeadportraitEditing = true;
      },

      typeName(type) {
        let list = this.groupTypeList;
        let typeName = '';

        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          if (item.value == type) {
            typeName = item.title;
            break;
          }
        }
        return typeName;
      },

      submitCancel() {
        this.isEdting = false;
      },

      submitUserEdit() {
        let name = this.teamName.removeBlanks();
        let type = this.teamType;
        let typeName = this.teamTypeName.removeBlanks();
        if (type != 0) {
          typeName = this.typeName(type);
        } else if (typeName == '') {
          this.$toast('请输入类型名称！');
          return;
        }

        let setupDate = '';
        if (this.teamCreateDate instanceof Date && !isNaN(this.teamCreateDate.getTime())) {
          setupDate = this.$moment(this.teamCreateDate).format('yyyy-MM-DD');
        }
        let contacts = this.teamAgentName.removeBlanks();
        let tel = this.teamAgentPhone.removeBlanks();
        if (tel != '' && !tel.isPhoneNumber()) {
          this.$toast('手机号格式不正确！');
          return;
        }

        if (contacts != '') {
          if (tel == '') {
            this.$toast('请输入联系人手机号！');
            return;
          }
        }
        if (tel != '') {
          if (contacts == '') {
            this.$toast('请输入联系人姓名！');
            return;
          }
        }

        let desc = this.teamProfile;
        let area = this.teamArea.province + ',' + this.teamArea.city + ',' + this.teamArea.area;
        let params = {
          name,
          sFoundedDate: setupDate,
          type: type,
          typeName: typeName,
          contacts,
          tel,
          desc,
          area,
          flag: 0
        };
        //
        let _this = this;
        this.$store.state.http.ajax.ucProfileUpdate(params, function (data) {
          if (data.code == 0) {
            _this.$toast('提交成功');
            _this.$router.go(0);
          } else {
            _this.$toast('提交失败');
          }
        },function (data) {
          _this.$toast('提交失败，请重试！');
        });
      }
    }
  }
</script>

<style>
  #group_home_page_outer .date-input-class {
    color: #333;
    height: 30px;
    width: 100%;
    text-indent: 10px;
    text-align: left;
  }

  #group_home_page_outer .border-red-color {
    border: solid 1px #e71432;
  }

  #group_home_page_outer .border-gold-color {
    border: solid 1px #cbb042;
  }

  .area-dispatcher-red, .area-dispatcher-gold {
    width: 100%;
  }


  .area-dispatcher-red label, .area-dispatcher-gold label {
    height: 30px;
    width: 32%;
    min-width: 70px;
  }

  .area-dispatcher-red label select {
    height: 100%;
    width: 100%;
    border: solid 1px #fc1a34;
  }

  .area-dispatcher-gold label select {
    height: 100%;
    width: 100%;
    border: solid 1px #cbb042;
    text-indent: 10px;
  }

</style>

<style scoped>

  input {
    outline: none;
  }

  #group_home_page_outer {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding-bottom: 30px;
    padding-left: 5px;
    padding-right: 5px;
  }

  #group_home_page_outer > div {
    min-height: 550px;
  }

  #group_home_page_left {
    width: 100%;
    min-width: 290px;
    margin-top: 30px;
    padding-top: 105px;
    padding-bottom: 105px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
  }

  #group_home_page_right {
    padding: 1vh 2vw 8vh 2vw;
    width: 90%;
    margin-top: 30px;
    min-width: 290px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
  }

  #group_home_page_right > div {
    margin-top: 4vh;
  }


  #group_home_page_right > div:first-child {
    width: 100%;
    padding-right: 10px;
  }

  #group_home_page_right > div:last-child {
    width: 100%;
  }

  #user_info_display > div, #user_info_edit > div {
    width: 90%;
    /*min-width: 250px;*/
  }


  #group_home_page_user_img {
    width: 120px;
    height: 120px;
    border-radius: 60px;
  }


  .group_home_page_label_1 {
    font-size: 1rem;
    color: #333;
    margin-top: 20px;
  }

  .group_home_page_left_name {
    font-size: 1.5rem;
    color: #333;
  }

  .group_home_page_label_2 {
    font-size: 0.8rem;
    color: #999;
    letter-spacing: 3px;
    margin-top: 30px;
  }

  .group_home_page_label_3 {
    font-size: 1rem;
    color: #999;
    margin-top: 50px;
  }

  #person_home_page_stars_out {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

  #person_home_page_stars_out img {
    width: 21px;
    height: 21px;
    margin-left: 5px;
  }

  #person_home_page_stars_out img:first-child {
    margin-left: 0;
  }

  .group_home_right_title {
    font-size: 1.5rem;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .person_infor_table th, .person_infor_table td {
    border: none;
    font-size: 1.2rem;
    text-align: left;
    padding-left: 0;
    padding-right: 0;
  }

  .person_infor_table th {
    width: 8rem;
  }

  .person_infor_table td {
    /*background-color: yellow;*/
  }

  .table_li_text {
    font-size: 1.2rem;
    color: #333;
    padding-top: 5px;
  }

  .border-red-color {
    border: solid 1px #e71432;
  }

  .border-gold-color {
    border: solid 1px #cbb042;
  }

  .background-red-color {
    background-color: #e71432;
  }

  .background-gold-color {
    background-color: #cbb042;
  }

  #group_user_info > div:first-child {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    /*background-color: yellow;*/
  }

  .user_info_head_edit {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  #user_info_display, #user_info_edit {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .user_info_ul {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
  }

  .user_info_label {
    font-size: 1rem;
    color: #111;
    text-align: left;
    width: 76px;
    letter-spacing: 1.5px;
    align-self: flex-start;
  }

  .user_info_text {
    font-size: 1rem;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    max-width: 67%;
  }

  .user_info_profile {
    font-size: 1rem;
    color: #666;
    max-width: 80%;
  }

  #group_user_vips_info {
    margin-top: 30px;
  }

  #group_form_submit {
    font-size: 1rem;
    background-color: white;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 15px;

  }

  #user_info_edit .user_info_label {
    margin-top: 5px;
  }

  .user_info_input {
    color: #666;
    border: solid 1px #ccc;
    background-color: white;
    font-size: 1rem;
    height: 30px;
    border-radius: 4px;
    text-indent: 15px;
    width: 60%;
  }

  .user_info_textarea {
    color: #666;
    border: solid 1px #ccc;
    background-color: white;
    font-size: 1rem;
    padding: 5px;
    width: 60%;
    height: 120px;
  }


  .header-left-td {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  .header-left-td > div {
    font-size: 1.5rem;
    font-weight: bold;
    padding-top: 5px;
  }

  .header-left-td > a {
    margin-left: 5px;
    padding: 5px;
  }

  .header-left-td img {
    width: 15px;
    height: auto;
  }

  .header-right-td {
    /*display: flex;*/
    /*width: 35%;*/
    /*flex-direction: row;*/
    /*flex-wrap: nowrap;*/
    /*justify-content: flex-end;*/
    /*align-items: center;*/
  }

  #group_home_page_right thead tr > td:first-child {
    width: 35%;
  }

  #group_home_page_right thead tr > td:last-child {
    width:65%;
    text-align: right;
  }

  #group_home_page_right thead input {
    border: none;
    font-size: 1rem;
    height: 26px;
    border-radius: 13px;
    padding: 5px 15px;
    color: white;
    font-weight: bold;
  }


  #group_home_page_right table tbody th {
    font-size: 1rem;
    font-weight: bold;
    color: #333;
  }

  #group_home_page_right table tbody td {
    font-size: 1rem;
    color: #666;
    padding: 5px 0;
  }

  #group_home_page_right tbody input {
    font-size: 1rem;
    width: 100%;
    text-align: left;
    text-indent: 15px;
    color: #333;
    padding: 5px 0;
  }

  #group_home_page_right tbody select {
    padding: 5px;
    font-size: 1rem;
    width: 100%;
    /*text-align: center;*/
    text-indent: 3px;
    color: #333;
  }

  #group_home_page_right tbody textarea {
    padding: 5px;
    font-size: 1rem;
    color: #333;
    width: 100%;
    text-indent: 10px;
    height: 100px;
  }

  @media screen and (min-width: 645px) {
    .user_info_profile {
      font-size: 1rem;
      color: #666;
      max-width: 70%;
    }
  }

  @media screen and (min-width: 768px) {
    #group_home_page_outer {
      justify-content: space-between;
    }
    #group_home_page_left {
      width: 40%;
    }

    #group_home_page_right {
      width: 55%;
    }
  }


  @media screen and (min-width: 1120px) {

    #group_home_page_right > div:first-child {
      width: 60%;
    }

    #group_home_page_right > div:last-child {
      width: 40%;
    }
    #user_info_display > div:first-child, #user_info_edit > div:first-child {
      width: 40%;
    }

    #user_info_display > div:last-child, #user_info_edit > div:last-child {
      width: 60%;
    }

    #user_info_display > div:last-child .user_info_profile, #user_info_edit > div:last-child .user_info_profile {
      max-width: 70%;
    }
  }

  .header-fore-div {
    background-color: rgba(0,0,0,0.3);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    border-radius: 60px;
    line-height: 120px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/group/GroupHomePage.vue